export default "__VITE_ASSET__b433dea1__"